import { Component, Input } from '@angular/core';
import { Image } from 'src/app/user/tribe';
import { getAssetUrl } from '../asset';

@Component({
    selector: 'app-avatar',
    template: `<img [src]="src" alt="user's avatar" />`,
    styleUrls: ['./avatar.component.scss'],
    standalone: false
})
export class AvatarComponent {
  @Input()
  image?: Image;

  get src() {
    if (!this.image) {
      return '';
    }
    return getAssetUrl(this.image.path);
  }
}
